import { event as sendEvent } from '@zillow/universal-analytics';
import { createZrmListingInfo, createZrmUserInfo } from './utils';
import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

// https://dataportal.zillowgroup.net/event-registry/7511
export const emitGetStartedEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  sendEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '7511',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_post_a_listing_page',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'get_started',
    },
    semantic: {
      semantic_event_nm: 'start_zrm',
      topic_tag_txt: ['zrm_growth'],
    },
    ...createZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7512
export const emitListingCreatedEvent = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  sendEvent({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: '7512',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_post_a_listing_page',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'create_listing',
    },
    semantic: {
      semantic_event_nm: 'create_listing',
      topic_tag_txt: ['zrm_growth'],
    },
    ...createZrmListingInfo(currentProperty),
    ...createZrmUserInfo(user),
  });
